import { html, nothing } from "lit";
import { PUBLIC_VENDOR_DOCS_ENABLED } from "./branding.ts";
import { buildExternalLinkRel, EXTERNAL_LINK_TARGET } from "./external-link.ts";

export function renderVendorDocsAnchor(props: {
  className?: string;
  href: string;
  label: string;
  title?: string;
}) {
  if (!PUBLIC_VENDOR_DOCS_ENABLED) {
    return nothing;
  }
  return html`
    <a
      class=${props.className ?? "session-link"}
      href=${props.href}
      target=${EXTERNAL_LINK_TARGET}
      rel=${buildExternalLinkRel()}
      title=${props.title ?? nothing}
      >${props.label}</a
    >
  `;
}
